import React from 'react';

// Components //
import Icon from '../Icon';

export default ({
  ...props,
}) => {
  return (
    <Icon
      viewBox="0 0 24 24"
      { ...props }
    >
      <path
        d="M9.30387745,17.7869719 L4.21273694,12.6608318 C3.92908769,12.3787966 3.92908769,11.9197392 4.21273694,11.6347036 L5.24114732,10.6085755 C5.52479658,10.3265403 5.98590845,10.3265403 6.26955771,10.6085755 L9.81880995,14.200024 L17.7304423,6.21152641 C18.0140915,5.9294912 18.4752034,5.9294912 18.7588527,6.21152641 L19.7872631,7.23765455 C20.0709123,7.51968977 20.0709123,7.98024728 19.7872631,8.2622825 L10.3322878,17.7899723 C10.0486386,18.0705073 9.58898132,18.0705073 9.30387745,17.7869719 L9.30387745,17.7869719 Z"
      />
    </Icon>
  );
}
